import React, { useEffect, useState } from "react";

import { trackPromise } from "react-promise-tracker";

import { Modal, message } from "antd";

import {
  obterPastasArquivosFilhos,
  detalhesPasta,
  listarPastas,
} from "../../services/http/pastaService";

import {
  registrarDownloadPasta,
  registrarVisualizacaoPasta
} from "../../services/http/dashboardService";

import Listagem from "./Listagem";

import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";

import "./styles.scss";
import { CloseOutlined } from "@mui/icons-material";

const initialPastaAtualState = [
  {
    name: "Nuvem de arquivos",
    id: "0",
  },
];

const ModalGerarLinkMultiplos = ({
  closeModal,
  openModal,
  IdUser,
  handleGerarMultiplosLinks,
}) => {
  const [pastaAtual, setPastaAtual] = useState(initialPastaAtualState);
  const [dataSource, setDataSource] = useState([]);
  const [showButtonAbrir, setShowButtonAbrir] = useState(false);
  const [pastaSelecionada, setPastaSelecionada] = useState("");

  useEffect(() => {
    pesquisarPastasArquivos(1);
  }, []);

  const buscarPastasFilhas = (idPasta, tipo) => {
    if (tipo == "pasta") {
      trackPromise(
        obterPastasArquivosFilhos(idPasta, 9999, 1)
          .then((res) => {
            if (!res.fail && res.data) {
              setDataSource(res.data);
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    }
  };

  const registrarVisualizacaoPastas = (idPasta) => {
    trackPromise(
      registrarVisualizacaoPasta(idPasta)
        .then((res) => {
          if (!res.fail) {
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const pesquisarPastasArquivos = (page) => {
    trackPromise(
      listarPastas(IdUser, page, 9999)
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const incluirPastaSelecionada = (id, tipo) => {
    if (tipo.toLocaleLowerCase() == "pasta" && id != "0") {
      buscarPastasFilhas(id, "pasta");
      trackPromise(
        detalhesPasta(id)
          .then((res) => {
            if (!res.fail && res.data) {
              const pasta = res.data;
              let novoArray = [];

              let novaPasta = {
                name: pasta.nome,
                id: pasta.id,
              };

              if (pastaAtual.length == 1) {
                setPastaAtual((prevent) => [...prevent, novaPasta]);
              } else {
                let pastaExistsIndex = pastaAtual.findIndex(
                  (item) => item.id == pasta.id
                );

                if (pastaExistsIndex > 0) {
                  pastaAtual.forEach((item, index) => {
                    if (index <= pastaExistsIndex) {
                      novoArray.push({
                        name: item.name,
                        id: item.id,
                      });
                    }
                  });

                  setPastaAtual(novoArray);
                } else {
                  let pastaPaiIndex = pastaAtual.findIndex((item) => {
                    return item.id == pasta.idParent;
                  });

                  if (pastaPaiIndex > 0) {
                    setPastaAtual((prevent) => [...prevent, novaPasta]);
                  } else {
                    let index = pastaAtual.length - 1;
                    pastaAtual[index] = novaPasta;
                    setPastaAtual(pastaAtual);
                  }
                }
              }
            }
            registrarVisualizacaoPastas(id);
          })
          .catch((error) => {
            console.error(error);
          })
      );
    } else if (id == "0" && tipo == "pasta") {
      setPastaAtual(initialPastaAtualState);
      pesquisarPastasArquivos(1);
    }
  };

  const selecionarItensParaLinks = () => {
    handleGerarMultiplosLinks(dataSource);
  };

  const handleSelectRowClick = (id, tipo) => {
    if (tipo == 0) {
      setShowButtonAbrir(true);
      setPastaSelecionada(id);
    } else {
      setPastaSelecionada("");
      setShowButtonAbrir(false);
    }
  };

  const handleAbrirPastaSelecionada = () => {
    if (pastaSelecionada) {
      incluirPastaSelecionada(pastaSelecionada, "pasta");
    } else {
      message.warning("Selecione uma pasta");
    }
  };

  return (
    <Modal
      title={<span className="modal-title-novoLink">Criar novo link</span>}
      visible={openModal}
      className="modal-linksNovo "
      closable={false}
      destroyOnClose={true}
      footer={[
        <div className="div-buttons ">
          <button className="button-links button-cancelar" onClick={closeModal}>
            CANCELAR
          </button>
          <button
            className="button-links button-abrir "
            onClick={handleAbrirPastaSelecionada}
          >
            ABRIR
          </button>
          <button
            className="button-links button-selecionar"
            onClick={selecionarItensParaLinks}
          >
            SELECIONAR
          </button>
        </div>,
      ]}
    >
      <CloseOutlined onClick={closeModal} className="custom-close-icon" />
      <div className="espacoInternoModalLink">
        <div className="div-titulo">
          <span className="span-titulo" style={{ color: "#000" }}>
            Nuvem de arquivos
          </span>
          <div className="div-divisor">
            <hr className="linhaHr" />
            <hr className="linhaHr" />
          </div>
        </div>
        <div>
          {pastaAtual.map((item) => (
            <button
              className="button-navegacao p-0 mt-2 mb-4"
              onClick={() => incluirPastaSelecionada(item.id, "pasta")}
            >
              {item.name + " >"}
            </button>
          ))}
        </div>
        <div className="row">
          <Listagem
            data={dataSource}
            buscarPastasFilhas={incluirPastaSelecionada}
            handleSelectRowClick={handleSelectRowClick}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ModalGerarLinkMultiplos;
